import { render } from "./CollectionStats.vue?vue&type=template&id=5cf3a89a"
import script from "./CollectionStats.vue?vue&type=script&lang=js"
export * from "./CollectionStats.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__